import cx from 'classnames'
import { type PropertyValue } from 'api/clients/PropertyClient'
import { NumberFormat } from 'common/PropertyForm/Types/Number'
import { formatNumberValue } from '../utils'
import Styles from '../PropertyValue.module.scss'

interface Props {
  propertyValue?: PropertyValue
  format?: NumberFormat
  disabled?: boolean
}

const Number = ({ propertyValue, format, disabled }: Props) => (
  <div className={cx(Styles.number, { [Styles.disabled]: disabled })}>
    {formatNumberValue(propertyValue?.value, format)}
  </div>
)

export default Number
